export const weeks = [
    { key: "Last 4 Weeks", value: 4, text: "Last 4 Weeks" },
    { key: "Last 8 Weeks", value: 8, text: "Last 8 Weeks" },
    { key: "Last 12 Weeks", value: 12, text: "Last 12 Weeks" }
]

export const groupBy = [
    { key: "Site", value: 0, text: "Site" },
    { key: "Region", value: 1, text: "Region" }
]

export const promoTypeOptions = [
    { key: "All (Default)", value: -1, text: "All (Default)" },
    { key: "Promo Cash", value: 1, text: "Promo Cash" },
    { key: "Promo Tickets", value: 2, text: "Promo Tickets" },
]

export const securityViewTypes = [
    { 
        key: "Variance", 
        value: 1, 
        text: "Variance", 
        graphOptions: [
            { key: "Total", value: 0, text: "Total" },
            { key: "Notes", value: 1, text: "Notes" },
            { key: "Coins", value: 2, text: "Coins" },
            { key: "Handpay", value: 3, text: "Handpays" }
        ]
    },
    { 
        key: "Promo Cash", 
        value: 2, 
        text: "Promo Cash", 
        graphOptions: [] 
    },
    { 
        key: "Deductions",
        value: 3,
        text: "Other Deductions",
        graphOptions: [
            { key: "Petty Cash", value: 0, text: "Petty Cash" },
            { key: "ATM Trans", value: 1, text: "ATM Trans" },
            { key: "Shortages", value: 2, text: "Shortages" },
        ]
    },
]

export const revenueViewTypes = [
    { 
        key: "Revenue",
        value: 0,
        text: "Revenue",
        graphOptions: [
            { key: "Gross", value: 0, text: "Gross"},
            { key: "Net", value: 1, text: "Net" },
            { key: "Net To Gross", value: 3, text: "Net To Gross" }
        ]
    },
    /*
    { 
        key: "Promo Cash",
        value: 4,
        text: "Promo Cash",
        graphOptions: [
            { key: "Promo Cash", value: 0, text: "Promo Cash"},
            { key: "Promo Cash to Gross", value: 1, text: "Promo Cash to Gross" },
            { key: "Promo Cash to M.N.I", value: 2, text: "Promo Cash to M.N.I" }
        ]
    },
    */
]